<script setup lang="ts">
import AppsButtons from '@features/apps/components/AppsButtons/AppsButtons.vue'
import AppsPhones from '@features/apps/components/AppsPhones/AppsPhones.vue'
import AppsQrCode from '@features/apps/components/AppsQrCode/AppsQrCode.vue'
import AppsSocialNetworks from '@features/apps/components/AppsSocialNetworks/AppsSocialNetworks.vue'
import AppsTitle from '@features/apps/components/AppsTitle/AppsTitle.vue'

import { APPS_LANDING_SEO } from '@features/apps/constants'
import { createSeoHead } from '@shared/nuxt/createSeoHead'
import { useResponsive } from '@shared/nuxt/useResponsive'

const { isDesktop } = useResponsive()

const { $host } = useNuxtApp()
const route = useRoute()

const { title, description } = APPS_LANDING_SEO

useHead({
  title,
  ...createSeoHead(
    $host,
    {
      title,
      keywords: '',
      description,
    },
    route.fullPath,
    route.path,
  ),
})
</script>

<template>
  <div class="apps-page">
    <div class="apps-page__info">
      <apps-title class="apps-page__title-component" />
      <apps-buttons class="apps-page__buttons-component" />
      <apps-social-networks />
    </div>

    <div class="apps-page__phones-container">
      <apps-phones class="apps-page__phones" />
      <apps-qr-code v-if="isDesktop" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.apps-page {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  padding: 0 20px 40px;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    content: '';
    background-image: url('../assets/background-heart-mobile.svg');
    background-position: left -25px top 30px;
    background-size: 120%;
  }

  &__info {
    z-index: 1;
  }

  &__title-component {
    margin-top: 0;
  }

  &__buttons-component {
    margin-top: 32px;
    margin-bottom: 40px;
  }

  &__phones-container {
    z-index: 1;
    display: flex;
    justify-content: center;
  }

  &__phones {
    width: 100%;
    max-width: 382px;
    margin-top: 49px;
  }

  @include media($bp-tablet) {
    padding-bottom: 80px;

    &::before {
      background-position: left 5px top 35px;
      background-size: 100%;
    }

    &__title-component {
      margin-top: 120px;
    }

    &__buttons-component {
      margin-top: 64px;
      margin-bottom: 78px;
    }

    &__phones {
      margin-top: 83px;
    }
  }

  @include media($bp-desktop-mini) {
    display: grid;
    flex: 1;
    grid-template-columns: 1fr 1fr;
    padding: 40px 0 90px;

    &::before {
      background-image: url('../assets/background-heart-desktop.svg');
      background-position: right -105px top 70px;
      background-size: 120%;
    }

    &__title-component {
      margin-top: 117px;
    }

    &__phones-container {
      display: grid;
      grid-template-columns: minmax(1px, 372px) max-content;
      gap: 80px;
    }
  }

  @include media($bp-desktop) {
    &::before {
      background-position: right -165px top 60px;
      background-size: 125%;
    }
  }
}
</style>
